// extracted by mini-css-extract-plugin
export default {"sponsorBlock":"index_sponsorBlock__2BMJD"};